import { render, staticRenderFns } from "./SupplierMaintain.vue?vue&type=template&id=85f2c6b2&scoped=true"
import script from "./SupplierMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f2c6b2",
  null
  
)

export default component.exports